import {createRouter, createWebHashHistory} from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Layout from "../components/Layout.vue";

NProgress.configure({
    showSpinner: false,
});

// 2. 定义路由配置
const routes = [
    {path: "/", redirect: "/index"},
    {
        path: "/login",
        name: "Login",
        component: () => import("@/pages/login/index.vue"),
    },
    {
        path: "/register",
        name: "register",
        component: () => import("@/pages/register/index.vue"),
    },
    {
        path: "/",
        name: "home",
        component: Layout,
        children: [
            {
                path: "index",
                name: "index",
                component: () => import("@/pages/index/index.vue"),
            },
        ],
    },
    {
        path: "/announcement",
        name: "announcement",
        component: Layout,
        children: [
            {
                path: "zb",
                name: "zb",
                component: () => import("@/pages/announcement/zb.vue"),
            },
            {
                path: "fzb",
                name: "fzb",
                component: () => import("@/pages/announcement/fzb.vue"),
            },
            {
                path: "history",
                name: "history",
                component: () => import("@/pages/announcement/history.vue"),
            },
            {
                path: "details",
                name: "Details",
                component: () => import("@/pages/announcement/details.vue"),
            },
        ],
    },
    {
        path: "/product",
        name: "product",
        component: Layout,
        children: [
            {
                path: "list",
                name: "list",
                component: () => import("@/pages/product/index.vue"),
            },
        ],
    },
    {
        path: "/company",
        name: "company",
        component: Layout,
        children: [
            {
                path: "profile",
                name: "profile",
                component: () => import("@/pages/company/profile.vue"),
            },
        ],
    },
    {
        path: "/invitation",
        name: "invitation",
        component: Layout,
        children: [
            {
                path: "caigou",
                name: "caigou",
                component: () => import("@/pages/invitation/caigou.vue"),
            },
            {
                path: "feicaigou",
                name: "feicaigou",
                component: () => import("@/pages/invitation/feicaigou.vue"),
            },
            {
                path: "contract",
                name: "contract",
                component: () => import("@/pages/invitation/contract.vue"),
            },
            {
                path: "details",
                name: "details",
                component: () => import("@/pages/invitation/details.vue"),
            },
        ],
    },
];

// 3. 创建路由实例
const router = createRouter({
    history: createWebHashHistory(),
    routes, // short for `routes: routes`
});
const whiteRoutes = ["/login"];
const accessToken = sessionStorage.getItem("accessToken");
router.beforeEach((to, from, next) => {
    NProgress.start();
    next();
});

router.afterEach((e) => {
    NProgress.done()
});

const createRouter2 = () => new Router({
    mode: 'history',
    routes: []
})
export function resetRouter () {
    const newRouter = createRouter2()
    router.matcher = newRouter.matcher // the relevant part
}

export default router;
